import { Reviewer } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAvailableProgramCountryNominationReviewers: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  accessToken?: string,
) => Promise<Reviewer[]> = (fetchContext, programId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nomination-reviewers/available`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Reviewer[]>(fetchContext.errorStore, response, 'get available program country nomination reviewers'));
